module.exports = __webpack_public_path__ + "img/image01.2ae697dc.jpg";